import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminThemeContext = createContext();

export function AdminThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('admin_theme');
    return saved || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('admin_theme', theme);
    // Update document class for global styling
    document.documentElement.classList.remove('admin-light', 'admin-dark');
    document.documentElement.classList.add(`admin-${theme}`);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const isDark = theme === 'dark';

  // Theme-aware color classes
  const colors = {
    // Backgrounds
    bg: isDark ? 'bg-slate-900' : 'bg-gray-50',
    bgCard: isDark ? 'bg-slate-800/50' : 'bg-white',
    bgHeader: isDark ? 'bg-slate-800/50' : 'bg-white',
    bgSidebar: isDark ? 'bg-slate-900' : 'bg-white',
    bgInput: isDark ? 'bg-slate-800' : 'bg-gray-50',
    bgHover: isDark ? 'hover:bg-slate-800' : 'hover:bg-gray-100',
    bgActive: isDark ? 'bg-slate-700/50' : 'bg-gray-100',
    
    // Borders
    border: isDark ? 'border-slate-700' : 'border-gray-200',
    borderSidebar: isDark ? 'border-slate-800' : 'border-gray-200',
    
    // Text
    text: isDark ? 'text-white' : 'text-gray-900',
    textSecondary: isDark ? 'text-slate-400' : 'text-gray-600',
    textMuted: isDark ? 'text-slate-500' : 'text-gray-500',
    
    // Interactive
    btnOutline: isDark ? 'border-slate-600 text-slate-300' : 'border-gray-300 text-gray-700',
  };

  return (
    <AdminThemeContext.Provider value={{ theme, toggleTheme, isDark, colors }}>
      {children}
    </AdminThemeContext.Provider>
  );
}

export function useAdminTheme() {
  const context = useContext(AdminThemeContext);
  if (!context) {
    throw new Error('useAdminTheme must be used within an AdminThemeProvider');
  }
  return context;
}

export default AdminThemeContext;
